import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import ReCAPTCHA from 'react-google-recaptcha';
import Button from '../../redesign/web/components/Button';
import LabelledTextInput from '../../redesign/web/components/LabelledTextInput';



const SmsOptOut = (props) => {
    const { match } = props;
    const { key } = match.params;
    const [sent, setSent] = useState(false);
    const [mobile, setMobile] = useState('');
    const [recaptcha, setRecaptcha] = useState(null);


    const cleanPhone = (value) => {
        if (!value || typeof value !== 'string') return '';
    
        // Strip out all non-digits.
        value = value.replace(/[^\d]/g, '');
    
        // Ensure we start with +614 from standard numbers.
        value = value.replace(/^04/, '+614');
        value = value.replace(/^614/, '+614');
    
        // If we don't have the right length or don't start with +614 we're not a valid number.
        return value.indexOf('+614') === 0 && value.length === 12 ? value : '';
    };

    const onUnsubcribe = async () => {
        if (cleanPhone(mobile).length <= 0) return alert('Please provide a valid mobile number.');
        if (!recaptcha) return alert('Please complete the verification challenge.');

        try {
            await axios.post('/api/sms-opt-out', {
                number: mobile,
                optOutKey: key,
            });
            setSent(true);
        } catch (e) {
            console.log('An error has occured', e);
        }
    };

    const onChange = (number) => {
        setMobile(number);
    };

    const onChangeRecaptcha = (captcha) => {
        setRecaptcha(captcha);
    };

    return (
        <Container>
            	<Helmet
					title="Signup"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Signup' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
            <p>Blueshyft SMS Opt-Out</p>

            {!sent && (
                <div>
                    <div style={{ margin: 25 }}>
                        <LabelledTextInput
                            placeHolder="Mobile Number"
                            name="mobile"
                            type="text"
                            value={mobile}
                            onChange={(e) => {
                                onChange(e.target.value);
                            }}
                        />
                    
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <ReCAPTCHA
                                sitekey="6Lc7zysdAAAAAGWvn4wvU4iXXqZzDiaU8JH9guJW"
                                onChange={onChangeRecaptcha}
                            />
                    </div>
                 
                    <Button onSubmit={onUnsubcribe} text="Unsubscribe" />

                </div>
            )}
            {sent && <div>Unsubscribed. You may close this window.</div>}
        </Container>
    );
};

const Container = styled.section`
	padding: 100px 20px;
	margin: auto;
	text-align: center;
    font-size: 18px;
`;


export default withRouter(SmsOptOut);



// WEBPACK FOOTER //
// ./client/scenes/SmsOptOut/index.js